import { z } from 'zod';

import { BackgroundDto } from '~/types/dtos/background-dto';
import { ModelVariantDto } from '~/types/dtos/model-variant-dto';
import { PoseDto } from '~/types/dtos/pose-dto';
import type { ProductDto } from '~/types/dtos/product-dto';

export const productGeneratorSchema = z.object({
  products: z
    .array(z.any() as z.ZodType<ProductDto>)
    .min(1)
    .max(4)
});

export const modelGeneratorSchema = z.object({
  modelVariants: z
    .array(z.any() as z.ZodType<ModelVariantDto>)
    .min(1)
    .max(4)
});

export const poseGeneratorSchema = z.object({
  poses: z
    .array(z.any() as z.ZodType<PoseDto>)
    .min(1)
    .max(4)
});

export const backgroundGeneratorSchema = z.object({
  backgrounds: z
    .array(z.any() as z.ZodType<BackgroundDto>)
    .min(1)
    .max(4)
});

export enum GeneratorStep {
  Product = 'product',
  Model = 'model',
  Pose = 'pose',
  Background = 'background',
  Review = 'review'
}

export const completeGeneratorSchema = z.object({
  activeSteps: z.array(z.nativeEnum(GeneratorStep)),
  productStep: productGeneratorSchema.optional(),
  modelStep: modelGeneratorSchema.optional(),
  poseStep: poseGeneratorSchema.optional(),
  backgroundStep: backgroundGeneratorSchema.optional()
});

export const completeGeneratorActionSchema = z.object({
  productIds: z.array(z.string().uuid()).min(1).max(4),
  modelVariantIds: z.array(z.string().uuid()).min(1).max(4),
  poseIds: z.array(z.string().uuid()).min(1).max(4),
  backgroundIds: z.array(z.string().uuid()).min(1).max(4)
});

export type CompleteGeneratorSchema = z.infer<typeof completeGeneratorSchema>;
export type CompleteGeneratorActionSchema = z.infer<
  typeof completeGeneratorActionSchema
>;
